import { Aurelia, autoinject, bindable, bindingMode } from 'aurelia-framework';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { Config } from 'Config';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { I18N } from 'aurelia-i18n';
import { Toastr } from 'Code/Extension/Toastr';
import { Router } from 'aurelia-router';

@autoinject
export class PasswordResetConfirm {
    @bindable({ defaultBindingMode: bindingMode.toView }) password1: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) password2: string = StringHelper.Empty();

    public imageLogo: string = null;
    public progressImageLogo: string = null;
    public i18n: I18N = null;
    private _authService: AuthService = null;
    private _aurelia: Aurelia = null;
    private _element: any = null;
    private _isValid: boolean = true;
    private _badLogin: boolean = false;
    private _emptyPassword1: boolean = false;
    private _emptyPassword2: boolean = false;
    private badLoginMess: string = '';
    private regEx = new RegExp('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d~!§@#$%^&*/*+?-]{8,}$');
    private confirmId: string = null;
    private done: boolean = false;
    protected router: Router = null;

    constructor(authService: AuthService, aurelia: Aurelia, element: Element, i18n: I18N, router: Router) {
        this.i18n = i18n;
        this._authService = authService;
        this._aurelia = aurelia;
        this._element = element;
        this.router = router;
        // this._keypressCallback = this.keypressInput.bind(this);

        this.i18n.setLocale(this._authService.GetUserLocale());
    }

    async activate(params, routeConfig, $navigationInstruction) {
        if (await this._authService.LoginAsPublicUser(null)) {
            Config.Init();
            ($('#progress-overlayer-white') as any).fadeIn(50);
            await SystemService.Instance.ClearCache_All();
            await SystemService.Instance.GetSchema();
            ($('#progress-overlayer-white') as any).delay(1000).fadeOut(350);
        }
    }    

    protected GetQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    }

    async bind() {
        this.confirmId = this.GetQueryVariable('id');
        let response: any = await this._authService.PasswordResetConfirm(this.confirmId);
        console.log(1111, 'PasswordResetConfirm', response)
        if (ObjectHelper.ObjectIs(response)) {
            if (response.Status == 0) {

            }
            else {
                this.badLoginMess = response.Message;
                this.confirmId = null;
                this._badLogin = true;
            }
        }
        else{
            this.badLoginMess = this.i18n.tr('ErrorMessage');
            this.confirmId = null;
            this._badLogin = true;
        }

        this.imageLogo = Config.ImageLogo();
        this.progressImageLogo = Config.ProgressImageLogo();
    }

    private validateForm() {
        this._emptyPassword1 = StringHelper.IsNullOrEmpty(this.password1) || !this.regEx.test(this.password1) || this.password1 !== this.password2;
        this._emptyPassword2 = StringHelper.IsNullOrEmpty(this.password2) || !this.regEx.test(this.password2) || this.password1 !== this.password2;

        if (!this._emptyPassword1 && !this._emptyPassword2) {
            this._isValid = true;
        }
    }

    password1Changed(newValue) {
        this.validateForm();
    }

    password2Changed(newValue) {
        this.validateForm();
    }

    public async Login() {
        window.history.replaceState({}, document.title, window.location.origin);
        this._aurelia.setRoot('Login');
    }

    public async ResetPwd() {
        this._isValid = true;
        this._badLogin = false;
        this.badLoginMess = '';

        this.validateForm();

        if (!this._emptyPassword1 && !this._emptyPassword2 && this.password1 === this.password2) {
            let response: any = await this._authService.PasswordResetConfirmSave(this.confirmId, this.password1, this.password2);
            if (ObjectHelper.ObjectIs(response)) {
                if (response.Status == 0) {
                    this.done = true;
                    Toastr.Success('Toastr.Done', response.Message, true, 20000);
                }
                else {
                    this._badLogin = true;
                    this.badLoginMess = response.Message;
                }
            }
            else{
                this.badLoginMess = this.i18n.tr('ErrorMessage');
                this.confirmId = null;
                this._badLogin = true;
            }
        }
        else {
            this._isValid = false;
        }
    }
}